<template>
  <div class="container">
    <v-tabs
      v-model="mainTab"
      fixed-tabs
      background-color="blue accent-1 gray--text"
      class="elevation-1"
    >
      <v-tab>
        Nuevo Despacho
      </v-tab>
      <v-tab>
        Lista de despachos
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="mainTab">
      <v-tab-item class="elevation-1">
        <v-row>
          <v-col cols="12" sm="12" xs="12" md="3" lg="3" xl="3">
            <v-autocomplete
              v-model="shipping.provider"
              :items="providers"
              :loading="isLoading"
              :search-input.sync="providerSearch"
              color="white"
              hide-no-data
              hide-selected
              item-text="name"
              item-value="id"
              label="Proveedor"
              placeholder="Escriba parte del nombre"
              prepend-icon="mdi-database-search"
              return-object
              persistent-hint
              clearable
            ></v-autocomplete>
            <v-autocomplete
              v-model="shipping.facility"
              :items="facilities"
              :loading="isLoading"
              :search-input.sync="facilitySearch"
              color="white"
              hide-no-data
              hide-selected
              item-text="name"
              item-value="code"
              label="Planta de destino"
              placeholder="Escriba parte del nombre"
              prepend-icon="mdi-database-search"
              return-object
              persistent-hint
              clearable
            ></v-autocomplete>
            <v-btn text>Fecha de Despacho</v-btn>
            <date-picker placeholder="Fecha" class="dtpicker" v-model="shipping.shipping_date" @change="loadShippings" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
            <v-select
              v-model="shipping.shift"
              :items="shifts"
              item-text="name"
              item-value="id"
              label="Elija Turno"
              color="blue darken-3"
              persistent-hint
              return-object>
            </v-select>
            <v-text-field
              prepend-icon="mdi-file-document"
              label="Guia de Despacho"
              placeholder="Guia de Despacho"
              v-model="shipping.waybill"
              @change="loadWaybill"
            ></v-text-field>
            <v-autocomplete
              v-model="shipping.patent"
              :items="patents"
              :loading="isLoading"
              :search-input.sync="patentSearch"
              color="white"
              hide-no-data
              hide-selected
              item-text="IDENTIFICADOR"
              item-value="IDENTIFICADOR"
              label="Patentes"
              placeholder="Seleccione camión"
              prepend-icon="mdi-database-search"
              return-object
              clearable
            ></v-autocomplete>
            <v-text-field
              prepend-icon="mdi-file-document"
              label="Certificado"
              placeholder="Certificado"
              v-model="shipping.certificate"
            ></v-text-field>
            <v-btn
              color = "primary"
              @click="saveShipping"
            >Grabar</v-btn>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
            <v-row class="mx-1">
              <v-tabs
                v-model="tab"
                fixed-tabs
                background-color="blue accent-1 gray--text"
                class="elevation-1"
              >
                <v-tab>
                  <v-badge
                    color="green"
                    :content="plpBins"
                  >
                    Bins PLP
                  </v-badge>
                </v-tab>
                <v-tab>
                  <v-badge
                    color="green"
                    :content="otherBins"
                  >
                    Otros Bins
                  </v-badge>
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item class="elevation-1">
                  <v-row class="mx-1">
                    <v-col xs="12" sm="12" md="6" lg="2" xl="2">
                      <v-select
                        v-model="binColor"
                        :items="colors"
                        @change="loadBins"
                        item-text="name"
                        item-value="id"
                        label="Color"
                        color="blue darken-3"
                        persistent-hint
                        return-object>
                      </v-select>
                    </v-col>
                    <v-col xs="12" sm="12" md="6" lg="2" xl="2">
                      <v-select
                        v-model="binSize"
                        :items="sizes"
                        @change="loadBins"
                        item-text="name"
                        item-value="id"
                        label="Tamaño"
                        color="blue darken-3"
                        persistent-hint
                        return-object>
                      </v-select>
                    </v-col>
                    <v-col xs="12" sm="12" md="6" lg="2" xl="2">
                      <v-autocomplete
                        v-model="bin"
                        :items="bins"
                        :loading="isLoading"
                        :search-input.sync="binSearch"
                        color="white"
                        hide-no-data
                        hide-selected
                        item-text="number"
                        item-value="id"
                        label="Número de BIN"
                        placeholder="# bin"
                        prepend-icon="mdi-database-search"
                        return-object
                        @change="addBin"
                      ></v-autocomplete>
                    </v-col>
                    <v-col xs="12" sm="12" md="6" lg="3" xl="3">
                      <v-select
                        v-model="state"
                        :items="states"
                        item-text="name"
                        item-value="id"
                        label="Estado del bin"
                        color="blue darken-3"
                        persistent-hint
                        return-object>
                      </v-select>
                    </v-col>
                    <v-col xs="12" sm="12" md="2" lg="1" xl="1">
                      <v-btn @click="addBin" class="primary"><v-icon>mdi-plus</v-icon></v-btn>
                    </v-col>
                    <v-col xs="12" sm="12" md="2" lg="1" xl="1">
                      <v-btn @click="dialogCopy = !dialogCopy" class="secondary"><v-icon>mdi-content-copy</v-icon></v-btn>
                    </v-col>
                  </v-row>
                  <v-data-table 
                    :headers="binsListHeaders"
                    :items="binsListBody"
                    class="elevation-1"
                    dense
                    no-data-text="No hay bins"
                  >
                    <template v-slot:[`item.actions`]="{item}">
                      <v-icon
                        medium
                        @click="deleteBin(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab-item class="elevation-1">
                  <v-row class="mx-0">
                    <v-col xs="6" sm="4" md="3" lg="3" xl="3">
                      <v-select
                        v-model="otherOwner"
                        :items="otherOwners"
                        item-text="name"
                        item-value="id"
                        label="Elija Propietario"
                        color="blue darken-3"
                        persistent-hint
                        return-object>
                      </v-select>
                    </v-col>
                    <v-col xs="6" sm="4" md="3" lg="3" xl="3">
                      <v-select
                        v-model="color"
                        :items="colors"
                        item-text="name"
                        item-value="id"
                        label="Elija Color"
                        color="blue darken-3"
                        persistent-hint
                        return-object>
                      </v-select>
                    </v-col>
                    <v-col xs="6" sm="4" md="2" lg="2" xl="2">
                      <v-select
                        v-model="size"
                        :items="sizes"
                        item-text="name"
                        item-value="id"
                        label="Elija Tamaño"
                        color="blue darken-3"
                        persistent-hint
                        return-object>
                      </v-select>
                    </v-col>
                    <v-col xs="6" sm="4" md="2" lg="2" xl="2">
                      <v-text-field
                        placeholder="Cantidad"
                        v-model="quantity"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col xs="6" sm="4" md="2" lg="2" xl="2">
                      <v-btn @click="addOtherBin" dense class="primary"><v-icon>mdi-plus</v-icon></v-btn>
                    </v-col>
                  </v-row>
                  <v-data-table 
                    :headers="othersListHeaders"
                    :items="othersListBody"
                    class="elevation-1"
                    dense
                    no-data-text="No hay bins"
                    :hide-default-footer="true"
                    disable-pagination
                  >
                    <template v-slot:[`item.code`]="{item}">
                      <v-text-field
                        prepend-icon="mdi-barcode"
                        placeholder="Codigo"
                        v-model="item.code"
                        @change= "loadBin(item)"
                      >
                      </v-text-field>
                    </template>
                    <template v-slot:[`item.actions`]="{item}">
                      <v-icon
                        medium
                        @click="deleteOtherBin(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-tab-item>
              </v-tabs-items>
            </v-row>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item class="elevation-1">
        <v-row class="mx-1">
          <v-col cols="4">
            <v-btn @click="download" color="primary">Excel</v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field
                v-model="shippingSearch"
                append-icon="mdi-magnify"
                label="Escriba para filtrar despachos"
                single-line
                hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-data-table 
          :headers="shippingsListHeaders"
          :items="shippingsListBody"
          class="elevation-1"
          no-data-text="No hay despachos"
          :search="shippingSearch"
          :hide-default-footer="true"
                    disable-pagination
        >
          <template v-slot:[`item.shipping_date`]="{item}">
            {{ formatDate(item.shipping_date )}}
          </template>
          <template v-slot:[`item.actions`]="{item}">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-icon
                  medium
                  class="mr-2"
                  @click="editShipping(item)"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar despacho</span>
            </v-tooltip>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-icon
                  medium
                  class="mr-2"
                  @click="deleteShipping(item)"
                  v-on="on"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>Borrar despacho</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>
    
    <!-- Modal Copy -->
    <v-dialog
      v-model="dialogCopy"
      transition="fab-transition"
      width="600px"
    >
      <v-card>
        <v-card-title class="blue darken-2">
          Copiar lista de bins
        </v-card-title>
        <v-container>
          <v-textarea
            auto-grow
            filled
            rows="20"
            :value="copyBins"></v-textarea>
        </v-container>
        <v-card-actions>
          <v-btn
            @click="dialogCopy = false"
          >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal -->

    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :color="color"
    >
      {{ validation_message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  //datepicker vue2
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/es';

  export default {
    data: () => ({
      snackbar: false,
      sbcolor: 'green',
      validation_message: '',
      url_excel: '',
      shippingSearch: null,
      copyBins: '',
      bins1000: [],
      bins800: [],
      dialog: false,
      dialogCopy: false,
      success: null,
      mainTab: null,
      tab: null,
      isLoading: false,
      bin: null,
      binSearch: null,
      code: 0,
      shift: null,
      shifts: [],
      bins: [],
      state: null,
      states: [],
      company: null,
      companies: [],
      otherOwner: null,
      otherOwners: [],
      providers: [],
      facilities: [],
      facilitySearch: null,
      providerSearch: null,
      color: null,
      colors: [],
      size: null,
      binSize: 1,
      binColor: 1,
      sizes: [],
      quantity: '',
      patents: [],
      patentSearch: null,
      shippingIndex: -1,
      shipping: {
        id: 0,
        facility: {
          id: 0,
          code: ''
        },
        shift: {
          id: 0,
          name: ''
        },
        provider: {
          id: 0,
          name: ''
        },
        waybill: '',
        patent: '',
        shipping_date: new Date().toISOString().substr(0, 10),
      },
      shippingsListHeaders: [
        {
          text: 'Fecha',
          align: 'center',
          sortable: true,
          value: 'shipping_date',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Turno',
          align: 'center',
          sortable: true,
          value: 'shift.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Planta Destino',
          align: 'center',
          sortable: true,
          value: 'facility.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Patente',
          align: 'center',
          sortable: true,
          value: 'patent',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Guia Despacho',
          align: 'center',
          sortable: true,
          value: 'waybill',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Certificado',
          align: 'center',
          sortable: true,
          value: 'certificate',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Bins',
          align: 'center',
          sortable: true,
          value: 'bins',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      shippingsListBody: [],
      binsListHeaders: [
        {
          text: 'Codigo',
          align: 'center',
          sortable: true,
          value: 'bin.code',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Estado',
          align: 'center',
          sortable: true,
          value: 'state.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      binsListBody: [],
      othersListHeaders: [
        {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'quantity',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Propietario',
          align: 'center',
          sortable: true,
          value: 'company.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Color',
          align: 'center',
          sortable: true,
          value: 'color.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Tamaño',
          align: 'center',
          sortable: true,
          value: 'size.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      othersListBody: [],
    }),
    mounted() {
      this.loadFacilities();
      this.loadColors();
      this.loadSizes();
      this.loadStates();
      this.loadCompanies();
      this.loadShifts();
      this.loadPatents();
      this.loadOtherOwners();
      this.loadShippings();
    },
    methods:{
      async loadCompanies(){
        let url = `${this.base_url}companies`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.companies = response.data.data;
            this.providers = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadOtherOwners(){
        let url = `${this.base_url}other_owners`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.otherOwners = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadFacilities(){
        let url = `${this.base_url}facilities`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.facilities = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadColors(){
        let url = `${this.base_url}colors`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.colors = response.data.data;
            this.binColor = this.colors[0];
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadSizes(){
        let url = `${this.base_url}sizes`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.sizes = response.data.data;
            this.binSize = this.sizes[0];
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadStates(){
        let url = `${this.base_url}states`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.states = response.data.data;
            this.state = this.states[0];
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadShifts(){
        let url = `${this.base_url}shifts`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.shifts = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadPatents(){
        let url = `${this.base_url}tickets/patents`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.patents = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadBins(){
        let url = `${this.base_url}bins/to_ship/bysize/${this.binSize.id}/${this.binColor.id}`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.bins = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadBin(item){
        let url = `${this.base_url}bins/${item.code}`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.bin = response.data.data;
            let index = this.binsListBody.indexOf(item);
            this.binsListBody.splice(index, 1, this.bin);
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadWaybill(){
        let url = `${this.base_url}shippings/waybill/${this.shipping.waybill}`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.shipping.patent = response.data.patent;
            this.shipping.provider = response.data.proveedor;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadShippings(){
        let url = `${this.base_url}shippings/report/last/100`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.shippingsListBody = response.data.data.report_data;
            this.url_excel = this.storage_url + response.data.data.url_excel;
            this.loadBins();
        }).catch((error)=>{
            console.log(error);
        });
      },
      async saveShipping(){
        // validation
        this.success = null;
        this.errors = [];
        if(!this.shipping.provider.id){
          this.errors.push("Debe seleccionar proveedor");
        }
        if(this.shipping.facility == null || !this.shipping.facility.id){
          this.errors.push("Debe seleccionar planta de destino");
        }
        if(this.shipping.patent == ""){
          this.errors.push("Debe seleccionar una patente");
        }
        if(this.shipping.shift == null || !this.shipping.shift.id){
          this.errors.push("Debe seleccionar un turno");
        }
        if(!this.shipping.waybill){
          this.errors.push("Debe indicar guía de despacho");
        }
        if(!this.shipping.certificate){
          this.errors.push("Debe indicar número de certificado");
        }
        if(this.binsListBody.length == 0 && this.othersListBody.length == 0){
          this.errors.push("Debe ingresar bins");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(false);
          return;
        }
        let url = `${this.base_url}shippings`;
        let sendData = {
          'shipping':{
            'main': {
              'provider_id': this.shipping.provider.id,
              'facility_id': this.shipping.facility.id,
              'shipping_date': this.shipping.shipping_date,
              'shifts_id': this.shipping.shift.id,
              'patent': this.shipping.patent,
              'certificate': this.shipping.certificate,
              'waybill': this.shipping.waybill,
            },
            'plp_details': [],
            'other_details': []
          }
        };
        this.binsListBody.forEach(item => {
          let data = {
            'shippings_id': 0,
            'bins_id': item.bin.id,
            'states_id': item.state.id,
          }
          sendData.shipping.plp_details.push(data);
        });
        this.othersListBody.forEach(bin => {
          let data = {
            'shippings_id': 0,
            'companies_id': bin.company.id,
            'colors_id': bin.color.id,
            'sizes_id': bin.size.id,
            'quantity': bin.quantity
          }
          sendData.shipping.other_details.push(data);
        });
        if(this.shipping.id > 0){
          url = url + "/" + this.shipping.id;
          await this.axios.put(url, JSON.stringify(sendData), this.headers).then((response)=>{
            console.log(response.data.data);
            this.validation_message = "Grabado exitosamente!";
            this.cleanForm();
            this.showSnackBar(false);
          }).catch((error)=>{
            this.errors = error.response.data.data;
            this.validation_message = this.errors.join();
            this.showSnackBar(true);
          });
        }else{
          await this.axios.post(url, JSON.stringify(sendData), this.headers).then((response)=>{
            //this.shippingsListBody.push(response.data.data);
            console.log(response.data.data);
            this.cleanForm();
            this.showSnackBar(false);
            this.loadBins();
          }).catch((error)=>{
            this.errors = error.response.data.data;
            this.validation_message = this.errors.join();
            this.showSnackBar(true);
          });
        }
        this.loadShippings();
      },
      cleanForm(){
        this.binsListBody = [];
        this.othersListBody = [];
        this.shipping = {
          id: 0,
          facility: {
            id: 0,
            code: ''
          },
          shift: {
            id: 0,
            name: ''
          },
          waybill: '',
          patent: '',
          shipping_date: new Date().toISOString().substr(0, 10),
        };
        this.company = null;
        this.size = null;
        this.color = null;
        this.quantity = 0;
      },
      addBin(){
        if(!this.bin || this.bin == null){
          this.validation_message = "Debe elegir un bin";
          this.showSnackBar(true);
          return;
        }
        let bin = this.binsListBody.filter(item => {
          return item.bin.number == this.bin.number && item.bin.sizes_id == this.bin.sizes_id && item.bin.colors_id == this.bin.colors_id;
        });
        if(bin.length == 0){
          this.binsListBody.push({bin: this.bin, state: this.state});
          if(this.bin.sizes_id == 1){
            this.bins1000.push(this.bin.number);
          }
          if(this.bin.sizes_id == 2){
            this.bins800.push(this.bin.number);
          }
          this.generaCopia();
        }
      },
      generaCopia(){
        //copio bins de 800
        let arrAux = [];
        let t800 = "Bins PLP Azul 800 Lt con tapa y bolsa:\n";
        let count = 0;
        this.bins800.forEach(bin => {
          count += bin.length + 1;
          if(count < 48){
            arrAux.push(bin);
          }else{
            t800 += arrAux.join(",") + "\n";
            arrAux = [];
            arrAux.push(bin);
            count = bin.length + 1;
          }
        });
        t800 += arrAux.join(",") + "\n";
        //copio bins de 1000
        arrAux = [];
        count = 0;
        let t1000 = `Bins PLP Azul 1000 Lt con tapa y bolsa:\n`;
        this.bins1000.forEach(bin => {
          count += bin.length + 1;
          if(count < 48){
            arrAux.push(bin);
          }else{
            t1000 += arrAux.join(",") + "\n";
            arrAux.push(bin);
            count = bin.length + 1;
          }
        });
        t1000 += arrAux.join(",") + "\n";
        this.copyBins = `${t800}\n${t1000}`;
      },
      addOtherBin(){
        if(!this.otherOwner || !this.color || !this.size || isNaN(this.quantity) || this.quantity <= 0){
          this.validation_message = "Debe ingresar todos los valores";
          this.showSnackBar(true);
          return;
        }
        this.othersListBody.push({company: this.otherOwner, color: this.color, size: this.size, quantity: this.quantity});
      },
      editShipping(item) {
        this.mainTab = "0";
        this.shippingIndex = this.shippingsListBody.indexOf(item);
        this.shipping = Object.assign({}, item);
        this.binsListBody = this.shipping.plp_bins;
        this.othersListBody = this.shipping.other_bins;
      },
      deleteShipping(item) {
        this.$confirm('Desea borrar este despacho?').then(res => {
          if(res){
            let url = `${this.base_url}shippings/${item.id}`;
            this.axios.delete(url, this.headers).then((response)=>{
              console.log(response);
              const index = this.shippingsListBody.indexOf(item);
              this.shippingsListBody.splice(index, 1);
              this.showSnackBar(true);
            }).catch((error)=>{
                console.log(error);
                this.validation_message = "Error al borrar despacho";
                this.showSnackBar(false);
            });
          }
        });
      },
      deleteBin(item) {
        this.$confirm('Desea borrar este bin?').then(res => {
          if(res){
            const index = this.binsListBody.indexOf(item);
            this.binsListBody.splice(index, 1);
            if(item.bin.sizes_id == 2){
              const bid = this.bins800.indexOf(item.bin);
              this.bins800.splice(bid, 1);
            }
            if(item.bin.sizes_id == 1){
              const bid = this.bins1000.indexOf(item.bin);
              this.bins1000.splice(bid, 1);
            }
            this.generaCopia();
          }
        });
      },
      deleteOtherBin(item) {
        this.$confirm('Desea borrar este bin?').then(res => {
          if(res){
            const index = this.othersListBody.indexOf(item);
            this.othersListBody.splice(index, 1);
          }
        });
      },
      download(){
        window.location.href = this.url_excel;
      },
      showSnackBar(error){
        if(error){
          this.color = 'red';
        }else{
          this.color = 'green';
          this.validation_message = "Ejecutado exitosamente!";
        }
        this.snackbar = true;
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      },
      ...mapMutations(['actualizarBaseUrl']),
    },
    computed:{
      plpBins: function(){
        return this.binsListBody.length;
      },
      otherBins: function(){
        let quantity = 0;
        this.othersListBody.forEach(bin => {
          quantity += parseInt(bin.quantity);
        });
        return quantity;
      },
      ...mapState(['authenticated', 'loading', 'base_url', 'storage_url', 'headers'])
    },
    components:{
      DatePicker
    }
  }
</script>